import React from 'react';
import { Empty, theme } from 'codeArt/components/Base';
import Portal from 'codeArt/components/Portal';
import _AreaChart from 'codeArt/components/chart/AreaChart';
import { DashedPanel } from 'codeArt/components/accessory';
import _DonutChart from 'codeArt/components/chart/DonutChart';
import _BarChart from 'codeArt/components/chart/BarChart';
import _BarSpreadChart from 'codeArt/components/chart/BarSpreadChart';
import _ScatterChart from 'codeArt/components/chart/ScatterChart';
import { threePosition, Util } from 'codeArt/common';
import ReactEcharts from "echarts-for-react";

export const ChartYHanle = {
  numerical: 1,
  float: 2,
  ratio: 3,
  ratio100: 4,
}

export function getMinMAX(data) {
  let max = 0; let min = 100000000000000;
  data.forEach((t) => {
    if (t > max) max = t;
    if (t < min) min = t;
  });

  return { min, max };
}

const numericalHanle = (data) => {
  let { min, max } = getMinMAX(data);

  min = min - parseInt(min / 5);
  max = max + parseInt(max / 5);
  let interval = (max - min) / 5;
  return { format: (v) => { return (v == min || (v + 0.001) >= max) ? parseInt(v) : "" }, min: min, max: max, interval: interval };
}

const floatHanle = (data, format) => {
  let { min, max } = getMinMAX(data);

  min = min - parseFloat((min / 5).toFixed(2));
  max = max + parseFloat((max / 5).toFixed(2));
  let interval = (max - min) / 5;
  return { format: format ? (v) => { return format(v, min, max, interval); } : (v) => { return (v == min || (v + 0.001) >= max) ? `${v.toFixed(2)}` : "" }, min: min, max: max, interval: interval };
}

const ratioHanle = (data) => {
  return floatHanle(data, (v, min, max, interval) => { return (v == min || (v + 0.001) >= max) ? `${v.toFixed(2)}%` : ""; });
}

const ratio100Hanle = (data) => {
  let { min, max } = getMinMAX(data);
  min = min - parseFloat((min / 5).toFixed(2));
  max = 1;
  let interval = (max - min) / 5;
  return { min: min, max: max, interval: interval, format: (v) => { return (v == min || (v + 0.001) >= max) ? `${parseInt((v * 100).toFixed(2))}%` : ""; } };
}

export const yHandls = {
  1: numericalHanle,
  2: floatHanle,
  3: ratioHanle,
  4: ratio100Hanle,
}

export class AreaChart extends React.Component {

  constructor(props) {
    super(props);
  }

  getY() {
    let handle = this.yHanle;
    if (handle) {
      let p = yHandls[handle](this.props.data);
      return { name: this.yName, ...p };
    }
  }


  getX() {
    return ["8:00", "9:00", "10:00", "11:00"];
  }

  getGrid() {

  }

  getMarkArea() {
    let data = this.getMarkData();
    if (!data) return;

    //{start,end}

    if (data.handle) {
      if (data.handle === "last") {
        let x = this.getX();
        data = { start: x[x.length - 2], end: x[x.length - 1] };
      }
    }

    let markArea = {
      itemStyle: {
        color: theme.color['light-grey']
      },
      data: [[{
        xAxis: data.start
      }, {
        xAxis: data.end
      }]]
    }

    return markArea;
  }

  getAxis() {

  }

  getData() {
    return { x: ["8:00", "9:00", "10:00", "11:00"] };
  }

  getMarkData() {

  }

  getDataY() {
    if (this.yHanle == 4) return { format: (v) => { return (v * 100).toFixed(1) + "%" } }
  }

  render() {
    let { data, showTitle } = this.props;
    let empty = data ? false : true;
    return (
      <DashedPanel title={showTitle === false ? '' : this.title} empty={"不适用"} line={empty} className="h-100" >
        {empty ? null : <_AreaChart line={true} lineStyle={{ type: "dashed" }}
          label={true}
          data={{
            y: [{ name: this.unit, color: theme.color.blue, data: data, ...this.getDataY() }], x: this.getX()
          }}
          area={false} legend={false} smooth={true}
          markArea={this.getMarkArea()}
          grid={{ left: '30', right: '10', top: "15", bottom: "0", containLabel: true, ...this.getGrid() }}
          y={{
            nameLocation: "center", nameGap: 32, min: 0, max: 500, interval: 100,
            axisLine: { "show": true }, axisTick: { "show": true }
            , ...this.getY()
          }} />}
      </DashedPanel>
    );
  }
}

export class BarSpreadChart extends React.Component {

  constructor(props) {
    super(props);
  }

  getY() {

  }

  getX() {

  }

  getDate(arry, value, name, hide) {
    return "";
  }

  getGrid(){
    return { left: '15', right: '35', bottom: '20' };
  }

  render() {
    let { data, className } = this.props;
    let empty = data ? false : true;
    return (
      <DashedPanel className={className || ''} title={this.title} empty={"不适用"} line={empty}>
        {empty ? null : <_BarSpreadChart grid={this.getGrid()} tooltipFormat={(arry, value, name, hide) => { return this.getDate(arry, value, name, hide); }} data={data} horizontal={true} x={{ min: 0, max: 10, interval: 1, ...this.getX() }} y={{ ...this.getY() }} />}
      </DashedPanel>
    );
  }
}

export class BarChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }


  getY() {

  }

  getX() {

  }

  getGrid() {

  }

  render() {
    let { title } = this.state;
    let { data, label, horizontal } = this.props;

    let empty = data ? false : true;
    return (
      <DashedPanel title={title || this.title || label} empty={"不适用"} line={empty}>
        {empty ? null : <_BarChart horizontal={horizontal} data={data} label={true} line={false} grid={{ left: 0, right: 0, bottom: 0, top: 50, ...this.getGrid() }} x={{ axisLine: { "show": true }, axisTick: { "show": true }, ...this.getX() }} y={{ axisLine: { "show": true }, axisTick: { "show": true }, min: 0, max: 5000, interval: 5000, ...this.getY() }} />}
      </DashedPanel>
    );
  }
}

export class DonutChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }


  render() {
    let { title } = this.state;
    let { data, label } = this.props;
    let empty = data ? false : true;
    return (
      <DashedPanel title={title || this.title || label} empty={"不适用"} line={empty}>
        {empty ? null : <_DonutChart data={data} label={label} />}
      </DashedPanel>
    );
  }
}

export class ScatterChart extends React.Component {

  constructor(props) {
    super(props);
    this.state = {

    }
  }

  getX() {

  }

  getY() {

  }

  getTip() {

  }

  getGrid() {

  }

  render() {
    let { data, label } = this.props;
    let empty = data ? false : true;
    return (
      <DashedPanel title={this.title || label} empty={"不适用"} line={empty}>
        {empty ? null : <_ScatterChart grid={this.getGrid()} data={data} label={label} tooltipFormat={(v) => { return this.getTip(v); }} x={{ ...this.getX() }} y={{ ...this.getY() }} />}
      </DashedPanel>
    );
  }
}


export class ManyAxisAreaChart extends React.Component {

  constructor(props) {
    super(props);
  }


  format(params) {
    let { data, } = this.props;
    let { x, y } = data;
    let name = params.seriesName;
    let value = params.data;
    let marker = params.marker;

    let item = y.find((t) => { return t.name == name }) || {};
    if (Util.empty(item)) item = y[0] || {};
    value = item.format ? item.format(value) : value;   //自定义显示数据格式
    let e = name.indexOf('series') > -1;

    if (e)
      return { marker, value };
    else
      return { marker, value, name };

  }

  handle(v) {
    let axis = { ...v }
    let format = v.format; let label = v.label;
    delete axis.format; delete axis.label;
    return { axis: axis, format: format, label: label }
  }

  getYMax() {
    let { data, y: yAxis } = this.props;
    let { y } = data;
    let interval = yAxis.interval || 1;

    let temp = y.map(({ data }) => Util.max(data));
    let maxValue = Util.max(temp);

    if (interval <= 1) return maxValue;

    //将y的最大值对齐interval
    let multiple = parseInt(maxValue / interval);
    if (maxValue % interval > 0) multiple++;
    return interval * multiple;

  }

  getOption() {
    let { data, y: yAxis, x: xAxis, xAxisInterval, title, tooltip, line, grid, label, titleStyle, animation, smooth, lineColor, legend, legendTop, } = this.props;
    let { x, y } = data;
    let option = {}; let my = this;
    if (title) {
      option.title = {
        text: title,
        textStyle: {
          fontSize: 16,
          fontWeight: 400,
          color: theme.color.dark
          , ...titleStyle
        }
      }
    }

    if (tooltip) {
      option.tooltip = {
        trigger: 'axis',
        formatter: function (params) {
          let tip = `${params[0].name}<br/>`;

          for (let i = 0; i < params.length; i++) {
            var data = my.format(params[i]);
            if (data.name)
              tip += `${data.marker} ${data.name} : ${data.value}<br/>`
            else
              tip += `${data.marker} ${data.value}<br/>`
          }

          return tip;
        }
      }
    }


    if (legend) { // 是否显示图标上方类型按钮
      let ldata = y.map((t, i) => { return t.name; })
      option.legend = { data: ldata };
      if (legendTop) option.legend.top = legendTop;
      else option.legend.bottom = 0;
    }

    option.grid = { left: '10', right: '25', containLabel: true }; //自定义图表两边留空
    option.grid = Object.assign(option.grid, grid);

    xAxis = xAxis.map((t) => {
      let xParams = my.handle(t);
      let item = {
        type: 'category',
        boundaryGap: x.boundaryGap, //折线图的两边预留位
        data: x,
        axisLabel: {
          formatter: function (value) {
            return xParams.format ? xParams.format(value) : value;
          },
          interval: xAxisInterval,   // 为0时，使x轴横坐标全部显示，大于0按照输入的数值缩略显示x轴横坐标
          ...xParams.label
        },
        ...xParams.axis
      };
      return item;
    });

    option.xAxis = xAxis;

    yAxis = yAxis.map((t) => {
      let yParams = my.handle(t);
      let item = {
        type: 'value',
        splitLine: { show: line, lineStyle: { color: lineColor, type: "dashed" } }, //网格线是否显示 
        axisLabel: {
          formatter: function (value) {
            return yParams.format ? yParams.format(value) : value;
          },
          ...yParams.label
        },
        max: this.getYMax(),
        ...yParams.axis
      }

      return item;
    });

    option.yAxis = yAxis;

    let series = y.map((t, i) => {
      let serie = {
        name: t.name,
        yAxisIndex: t.yAxisIndex || 0,
        type: 'line',
        symbol: 'circle',
        symbolSize: 2,
        sampling: 'average',
        color: t.color,
        data: t.data,
        label: !label ? null : {
          show: true,
          formatter: function (p) {
            var data = my.format(p);
            return data.value;
          }
        }
      }

      serie.itemStyle = {
        color: t.color,
      }

      serie.smooth = smooth; //曲线折线设置
      return serie;
    })

    option.animation = animation; //动画
    option.series = series;
    return option;
  }

  getEvents() {
    let { onClick } = this.props;
    if (!onClick) return {};
    return { 'click': onClick };
  }

  render() {
    return <ReactEcharts option={this.getOption()} notMerge={true} lazyUpdate={true} className={"w-100 h-100"} onEvents={this.getEvents()} />
  }
}

ManyAxisAreaChart.defaultProps = {
  title: "",
  grid: {},
  smooth: true,
  tooltip: true,
  label: true,
  line: true,
  legend: true,
  legendTop: true,
  y: [],
  x: [{ boundaryGap: true }],
  animation: true,
  xAxisInterval: 0,
  lineColor: "#f0f0f0",
}

ManyAxisAreaChart.propTypes = {
};

